import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import Message from 'src/component/Message'
import { history } from 'src/core/router'
import 'swiper/swiper-bundle.min.css'
import http from 'src/helper/http'
import { shareToLink } from 'src/helper/webviewFun'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
  }

  state = {
    lang: langM.ar,
    language: 'en',
    seachValue:'',
    userList:[],
    roomList:[],
    seachHad:false,
    link:'',
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid: uid
    })
    if (this.state.language == 'tr') {
      setDocumentTitle('Yönetici Kontrol Paneli')
    } else if (this.state.language == 'en') {
      setDocumentTitle('Admin control panel')
    } else if (this.state.language == 'ar') {
      setDocumentTitle('لوحة تحكم المشرف ')
    }
    // console.log(uid, 'uid')

    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid
    })
    this.getLink()
  }
  findForSeach = async() => {
     let {seachValue} = this.state
     let res = await http.post('/web/search/user/room',{keyword:seachValue})
     if (res.code== 0) {
     
       this.setState({
        userList:res.res.users? res.res.users:[],
        roomList:res.res.rooms? res.res.rooms:[],
        seachHad:true,
       })
     }
  }
  // 
  getLink = async()=>{
    let res = await http.post('/web/config/webrechargelink')
    if (res.code != 0) return
    this.setState({
      link:res.res.link
    })
  }
  setValue = (e) => {
    console.log(e.target.value)
    this.setState({seachValue:e.target.value})
  }
  goRoomSet=(e)=>{
    let {gid =0 } = e
    let {language} = this.state
    history.push(`/admin-control/bane-reset-room?gid=${gid}&language=${language}`)
  }
  goUserSet=(e)=>{
    let {uid} = e
    let {language} = this.state
    history.push(`/admin-control/admin-control-user?uid=${uid}&finduid=${uid}&language=${language}`)
  }
  render() {
    let { lang , seachValue , userList , roomList , seachHad, link } = this.state
    return (
      <div className='admin-control-panel'>
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>{lang.titleText}</div>
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e => this.setValue(e)} placeholder={lang.enterID}></input>
            <div className="find-line"></div>
            <div className={`find-btn ${seachValue.length > 0 ? 'havevalue' : ''}`} onClick={this.findForSeach}>{lang.find}</div>
          </div>
          {userList && userList.length>0 && <div className='user-root'>
             <div className='user-title'>{lang.userText}</div>
             {userList.map((item,index)=>{return(<div className="application-user-info" key={index} onClick={()=>this.goUserSet(item)}>
                <div className="avatar-root">
                  <img className="avatar-img" src={item.avatarurl}></img>
                  {item.gender == 1 && <img className="img-gender" src='/img/app/tradeUnion/man_icon.png'></img>}
                  {item.gender == 2 && <img className="img-gender" src='/img/app/tradeUnion/women_icon.png'></img>}
                </div>
                <div className="user-info">
                  <div className="user-info-top">
                    <div className="top-text">{item.nickname}</div>
                    
                  </div>
                  <div className="user-info-buttom">ID: {item.duid}</div>
                </div>
 
              </div>)})}
            </div>}
            
            {roomList && roomList.length>0 && <div className='user-root'>
             <div className='user-title'>{lang.roomText}</div>
             {roomList.map((item,index)=>{return(<div className="room-user-info" key={index} onClick={()=>this.goRoomSet(item)}>
                <div className="avatar-root">
                  <img className="avatar-img" src={item.logourl}></img>
                </div>
                <div className="user-info">
                  <div className="user-info-top">
                    <div className="top-text">{item.name}</div>
                    {item.medals && item.medals.map(item2=>{
                      return   <img className='country-icon' src={item2}></img>
                    })}
                  </div>
                  <div className='country'>
                      <img className='country-icon' src={item.countryIcon}></img>
                      {item.gType == 3 && <div className='game-type'>Game</div>}
                  </div>
                  <div className="user-info-buttom">{item.announcement}</div>
                </div>
              </div>)})}
            </div>}
          
            {seachHad && userList.length == 0 && roomList.length == 0 && <div className='not-found'>{lang.notFound}</div>}
        </div>
        <Message ref="msg" desc={this.state.desc} />
        {/* {roomList && !roomList.length>0 && <div className='web-link' onClick={async()=> {  await shareToLink(link)}}>{lang.webLink}</div>} */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/admin-control/admin-control-panel/index.js